import { useEffect, useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import useCustomHistory from 'src/hooks/useCustomHistory';
import Icon from 'src/components/Icon';
import { SLIDE_BANNER_KR, SLIDE_BANNER_GLOBAL } from 'src/constants/banner';
import { getUrlToHistory, isKorean } from 'src/services/util';
import { useUser } from 'src/UserContext';
import { PRODUCT_REGION } from 'src/constants/product';
import { useTranslation } from 'react-i18next';

function SlideItem({ bgImage, contentsImage, link }: { bgImage: string; contentsImage: string; link: any }) {
  return (
    <div className="bg-no-repeat bg-cover bg-center" style={{ height: '21.25rem', backgroundImage: `url(${bgImage})` }} onClick={link}>
      <div className="h-full bg-no-repeat bg-cover bg-center" style={{ backgroundImage: `url(${contentsImage})` }}></div>
    </div>
  );
}

export default function Slide(): JSX.Element {
  const { isInit, isLogin, userInfo } = useUser();
  const { i18n } = useTranslation();
  const history = useCustomHistory();
  const [slideBannerList, setSlideBannerList] = useState<Record<string, any>[]>([]);
  const [slider, setSlider] = useState<Slider | null>(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(true);

  useEffect(() => {
    if (!isInit) return;

    if (isLogin) {
      setSlideBannerList(userInfo.country === PRODUCT_REGION.KR ? SLIDE_BANNER_KR : SLIDE_BANNER_GLOBAL);
    } else {
      setSlideBannerList(isKorean() ? SLIDE_BANNER_KR : SLIDE_BANNER_GLOBAL);
    }
  }, [isInit, isLogin, userInfo, i18n.languages[0]]);

  return (
    <div className="relative">
      <Slider
        ref={(slider) => setSlider(slider)}
        {...{
          infinite: true,
          speed: 500,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          // swipe: false,
          autoplay: slideBannerList.length > 1,
          autoplaySpeed: 5000,
          afterChange: (index: number) => {
            setCurrentIndex(index);
          },
        }}
      >
        {slideBannerList.length > 0 &&
          slideBannerList.map((data, index) => {
            return (
              <SlideItem
                key={index}
                bgImage={data.bgImage}
                contentsImage={data.contentsImage[isKorean() ? 'ko' : 'en']}
                link={() => {
                  const urls = getUrlToHistory(data.link);
                  history.push(urls[0], urls[1]);
                }}
              />
            );
          })}
      </Slider>
      <div className="absolute bottom-0 pb-6 w-full flex flex-row justify-center items-center">
        <div className="bg-opacity-10 h-0.5 rounded-sm bg-white relative" style={{ width: slideBannerList.length * 1.875 + 'rem' }}>
          <div
            className="absolute rounded-sm bg-white w-7.5 h-full transition-transform duration-200"
            style={{
              transform: `translateX(${currentIndex * 100}%)`,
            }}
          ></div>
        </div>
        <button
          className="-mr-6 ml-1"
          onClick={() => {
            if (isPlaying) {
              setIsPlaying(false);
              slider && slider.slickPause();
            } else {
              setIsPlaying(true);
              slider && slider.slickPlay();
            }
          }}
        >
          <Icon name={isPlaying ? 'stop' : 'play'} size="20" />
        </button>
      </div>
    </div>
  );
}
